/**
 * Single source of truth for the app version pill shown in the
 * Doserne header + drawer. Bump `APP_BUILD` every time you also
 * bump `CACHE_NAME` in `public/sw.js`.
 *
 * The whole file is regenerated by `scripts/bump-version.js` — run
 *   `yarn version:bump`               (build +1)
 *   `yarn version:bump:patch|minor|major`
 * so `APP_BUILD_DATE` always reflects the actual moment of the
 * last version bump / deploy.
 *
 *   APP_SEMVER      → mirrors `frontend/package.json` "version"
 *   APP_BUILD       → mirrors the number at the end of `CACHE_NAME`
 *                     in `public/sw.js`
 *   APP_BUILD_DATE  → ISO timestamp written by bump-version.js
 */
export const APP_SEMVER = "0.1.1";
export const APP_BUILD = 23;
export const APP_BUILD_DATE = "2026-11-02T20:51:16.204Z";

/** Short label for the header pill: `v0.1.1 · b21` */
export const APP_VERSION = `v${APP_SEMVER} · b${APP_BUILD}`;

/**
 * Long label used in the drawer, e.g. `V0.1.1 · b21 · 09/feb 12:34`.
 * `locale` picks the month abbreviation language ("no", "ro", "en").
 * Times are rendered in the user's local timezone.
 */
export function formatAppVersionWithDate(locale = "no") {
  let stamp = "";
  try {
    const d = new Date(APP_BUILD_DATE);
    if (!isNaN(d.getTime())) {
      const day = String(d.getDate()).padStart(2, "0");
      const monthNames = {
        no: ["jan", "feb", "mar", "apr", "mai", "jun", "jul", "aug", "sep", "okt", "nov", "des"],
        ro: ["ian", "feb", "mar", "apr", "mai", "iun", "iul", "aug", "sep", "oct", "nov", "dec"],
        en: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"],
      };
      const months = monthNames[locale] || monthNames.no;
      const mon = months[d.getMonth()];
      const hh = String(d.getHours()).padStart(2, "0");
      const mm = String(d.getMinutes()).padStart(2, "0");
      stamp = `${day}/${mon} ${hh}:${mm}`;
    }
  } catch { /* ignore */ }
  return stamp ? `${APP_VERSION} · ${stamp}` : APP_VERSION;
}
